var React = require('react');

function IconDecrease (props) {
    return React.createElement("svg",props,React.createElement("path",{"data-name":"icon - decrease","d":"m3 0 3 4H0z","transform":"rotate(180 3 2)","style":{"fill":"#ff534a"}}));
}

IconDecrease.defaultProps = {"width":"6","height":"4","viewBox":"0 0 6 4"};

module.exports = IconDecrease;

IconDecrease.default = IconDecrease;
